"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const state_1 = __importDefault(require("../state"));
const assetsAreLoaded_1 = __importDefault(require("./assetsAreLoaded"));
const getAudioSourcesCount_1 = __importDefault(require("./definables/getAudioSourcesCount"));
const getImageSourcesCount_1 = __importDefault(require("./definables/getImageSourcesCount"));
const drawCoots_1 = __importDefault(require("./draw/drawCoots"));
const drawRectangle_1 = __importDefault(require("./draw/drawRectangle"));
const drawInteractHUD_1 = __importDefault(require("./draw/drawInteractHUD"));
const drawTimer_1 = __importDefault(require("./draw/drawTimer"));
const isCatStarving_1 = __importDefault(require("./isCatStarving"));
const drawGameOver_1 = __importDefault(require("./draw/drawGameOver"));
const getTilemap_1 = __importDefault(require("./definables/getTilemap"));
const drawVictory_1 = __importDefault(require("./draw/drawVictory"));
const drawTitle_1 = __importDefault(require("./draw/drawTitle"));
const levels_1 = __importDefault(require("../constants/levels"));
const drawTutorialHUD_1 = __importDefault(require("./drawTutorialHUD"));
const gameIsOngoing_1 = __importDefault(require("./gameIsOngoing"));
const drawLevelCompleteHUD_1 = __importDefault(require("./drawLevelCompleteHUD"));
const levelIsCompleted_1 = __importDefault(require("./levelIsCompleted"));
const drawCounterHUD_1 = __importDefault(require("./drawCounterHUD"));
const drawBedHUD_1 = __importDefault(require("./draw/drawBedHUD"));
const drawText_1 = __importDefault(require("./draw/drawText"));
const isPaused_1 = __importDefault(require("./isPaused"));
const render = () => {
    state_1.default.app.stage.removeChildren();
    (0, drawRectangle_1.default)("#000000", 1, 0, 0, gameWidth_1.default, gameHeight_1.default, 0);
    if ((0, assetsAreLoaded_1.default)()) {
        if (state_1.default.isAwaitingFocus) {
            (0, drawText_1.default)("Click to focus", "#ffffff", gameWidth_1.default / 2, gameHeight_1.default / 2, 1, gameWidth_1.default, 1, "center", "middle");
        }
        else if (state_1.default.isAtTitle) {
            (0, drawTitle_1.default)();
        }
        else if (state_1.default.won) {
            (0, drawVictory_1.default)();
        }
        else if ((0, isCatStarving_1.default)()) {
            (0, drawGameOver_1.default)();
        }
        else if ((0, gameIsOngoing_1.default)()) {
            (0, getTilemap_1.default)(state_1.default.level.tilemapSlug).draw();
            if ((0, levelIsCompleted_1.default)()) {
                (0, drawLevelCompleteHUD_1.default)();
                (0, drawTimer_1.default)();
            }
            else {
                (0, drawCoots_1.default)();
                if (state_1.default.isInBed) {
                    (0, drawBedHUD_1.default)();
                }
                else {
                    if ((0, isPaused_1.default)() === false) {
                        (0, drawInteractHUD_1.default)();
                        if (state_1.default.level === levels_1.default[0]) {
                            (0, drawTutorialHUD_1.default)();
                        }
                    }
                    if (state_1.default.level !== levels_1.default[0]) {
                        (0, drawCounterHUD_1.default)();
                    }
                    (0, drawTimer_1.default)();
                }
            }
        }
    }
    else {
        const current = state_1.default.loadedAssets;
        const total = (0, getImageSourcesCount_1.default)() + (0, getAudioSourcesCount_1.default)() + 1;
        const percent = current / total;
        const width = 192;
        const x = (gameWidth_1.default - width) / 2;
        const height = 32;
        const y = (gameHeight_1.default - height) / 2;
        (0, drawRectangle_1.default)("#343434", 1, x, y, width, height, 0);
        (0, drawRectangle_1.default)("#7b7b7b", 1, x, y, Math.round(width * percent), height, 0);
    }
    const entryYs = new Map;
    for (const entry of state_1.default.ySortEntries) {
        entryYs.set(entry.id, Math.max(entry.sprite.y + entry.sprite.height / 2, 0));
    }
    for (const entry of state_1.default.ySortEntries) {
        const y = entryYs.get(entry.id);
        if (typeof y !== "undefined") {
            entry.sprite.zIndex = y;
        }
    }
    state_1.default.app.stage.sortChildren();
    state_1.default.app.render();
    state_1.default.ySortEntries = [];
};
exports.default = render;
